import type { ReactNode } from 'react';
import { isString, isNumber, isNil } from '@wistia/type-guards';
import { truncateString } from '../truncateString';

/**
 * Applies maxChars truncation to React children
 */
export const applyMaxCharsToChildren = (children: ReactNode, maxChars?: number): ReactNode => {
  if (isNil(maxChars)) {
    return children;
  }

  if (isString(children)) {
    return truncateString(children, maxChars);
  }

  if (isNumber(children)) {
    const numberString = String(children);
    return truncateString(numberString, maxChars);
  }

  // for other types (React elements, arrays, etc.), attempt string conversion
  const textContent = typeof children === 'object' ? JSON.stringify(children) : String(children);
  return truncateString(textContent, maxChars);
};
